<template>
  <div class="content-wrapper">
    <div class="flex mb-4 overflow-visible">
      <div class="lg:w-full w-full bg-grid-color h-12 overflow-visible">
        <vs-card class="px-5 py-5 overflow-visible" ref="target">
          <div class="sticky-menu p-0 py-2" :class="{ sticking }">
            <div class="d-flex justify-between align-items-center">
              <div>
                <vs-button
                  class="mr-3 mb-2 px-12"
                  @click="validatePage"
                  size="large"
                  >Save
                </vs-button>
              </div>
            </div>
          </div>
          <vs-input
            v-model="page_title"
            class="mb-5  w-100 page-title"
            :placeholder="`Page Title`"
            block
            size="large"
          ></vs-input>

          <vs-input
            v-model="page_description"
            class="mb-5  w-100"
            :placeholder="`Page Description`"
            block
          ></vs-input>

          <hr />

          <div class="overflow-visible">
            <div class="tab-text overflow-visible">
              <div
                class="row page-content-wrapper ml-0"
                style="width: 100%;flex: 0 0 auto;flex-wrap: nowrap;padding-left:40px"
              >
                <div class="col col-auto"></div>
                <div class="col">
                  <div class="content-container" style=" overflow: visible;">
                    <div class="d-inline-flex align-items-center">
                      <div id="contentType" icon="list" class="mb-3">
                        <div class="d-flex  align-items-center">
                          <h2>{{ tag_item.title }}</h2>
                          <!-- <vx-tooltip :text="`For the best results on all devices, use an image that’s at least 2048 x 1152 pixels and 3MB or less.`" position="bottom" delay=".3s">
                            <i class="ml-2 mt-2 fa fa-question-circle" style="font-size: 18px;" aria-hidden="true"></i>
                          </vx-tooltip> -->
                          <!-- <div style="font-size: 1rem; color: #aaa">
                            For the best results on all devices, use an image that’s at least 2048 x 1152 pixels and 3MB or less.
                          </div> -->
                          <!-- <vs-button
                            class="add-option-button ml-5  "
                            @click="openContentDialog()"
                          >
                            Edit Item
                          </vs-button> -->
                        </div>
                      </div>
                    </div>
                    <div class="w-full">
                      <v-select
                        class="w-full"
                        v-model="selected_tag"
                        :onchange="addTag()"
                        :options="tag_select_options"
                        placeholder="Search available tags"
                      ></v-select>
                      <div class="mt-4">
                        <draggable
                          v-model="tags"
                          tag="div"
                          class="row mx-0"
                          :options="{
                            animation: 300
                          }"
                          ghost-class="ghost"
                          @start="drag = true"
                          @end="drag = false"
                        >
                          <div
                            class="col-auto px-1 cursor-move"
                            v-for="(tag_display, index) in tags"
                            :key="index"
                          >
                            <transition name="list" tag="div">
                              <vs-chip style="font-size: 14px;">
                                {{ tag_display }}
                                <div
                                  class="ml-2 "
                                  @click="removeTag(tag_display)"
                                >
                                  <i
                                    class="fas fa-times-circle cursor-pointer"
                                  ></i>
                                </div>
                              </vs-chip>
                            </transition>
                          </div>
                        </draggable>
                      </div>
                    </div>
                    <div style="overflow: auto;"></div>
                  </div>
                </div>
              </div>
              <hr />
              <draggable
                v-model="contents"
                :options="{
                  animation: 300,
                  handle: '.drag-handle'
                }"
                tag="div"
                ghost-class="ghost"
                @start="drag = true"
                @end="drag = false"
              >
                <transition-group
                  type="transition"
                  :name="!drag ? 'flip-list' : null"
                >
                  <div
                    v-for="(content, index) in contents"
                    :key="
                      `${index}:${content.content_id}:${content.content_uuid}`
                    "
                  >
                    <transition name="list" tag="div">
                      <div
                        v-if="content.show"
                        class="content-item d-flex align-items-start position-relative"
                        style="background: #ffffffe3; border-radius: 0.5rem"
                      >
                        <ContentCard
                          v-model="contents[index]"
                          :page_id="page_id"
                          :events="eventList"
                          :products="productsInSeller"
                          :videos="videos"
                          :onNewContent="
                            () => {
                              addContent(index);
                            }
                          "
                          :onCopyContent="
                            () => {
                              copyContent(index);
                            }
                          "
                          :onDelete="
                            () => {
                              showDeleteDialog(index);
                            }
                          "
                          :onMoveUp="
                            () => {
                              moveContentUp(index);
                            }
                          "
                          :onMoveDown="
                            () => {
                              moveContentDown(index);
                            }
                          "
                        />
                      </div>
                    </transition>
                    <hr />
                  </div>
                </transition-group>
              </draggable>
              <!-- <ContentComp :list="contents"></ContentComp> -->
            </div>
            <!-- <vs-button target="_blank" color="primary" @click="addContent()"
              >Add Content
            </vs-button>

            <div class="vx-row pt-2 mt-0">
              <div class="vx-col col-auto ml-auto">
                <vs-button class="mr-3 mb-2" @click="validatePage"
                  >Save
                </vs-button>
              </div>
            </div> -->
          </div>
        </vs-card>
      </div>
    </div>
    <vs-popup title="Delete Content?" :active.sync="confirmDeleteDialog">
      <div style="min-height: 100px" class="m-5">
        Are you sure you want to delete the Content?
      </div>
      <vs-divider />
      <div class="text-right">
        <vs-button
          style="display: inline-block"
          class="mr-2"
          @click="removeContent(deleteIndex)"
          >Delete</vs-button
        >
        <vs-button
          class="mr-3 mb-2"
          type="border"
          @click="confirmDeleteDialog = false"
          >Cancel
        </vs-button>
      </div>
    </vs-popup>

    <vs-popup title="Page update" :active.sync="successDialog">
      <div class="m-1">
        {{ successText }}
      </div>
      <vs-divider />
      <div class="text-right">
        <vs-button
          style="display: inline-block"
          class=""
          @click="successDialog = false"
          >OK</vs-button
        >
      </div>
    </vs-popup>

    <vs-popup title="Oops!" :active.sync="errorDialog">
      <div class="m-1">
        {{ errorText }}
      </div>

      <br />

      <vs-divider />
      <div class="text-right">
        <vs-button
          style="display: inline-block"
          class=""
          @click="errorDialog = false"
          >OK</vs-button
        >
      </div>
    </vs-popup>
  </div>
</template>

<script>
// import { Validator } from "vee-validate";
import Service from "@/services";
import { mapState } from "vuex";
import Option from "./Option.vue";
import ContentCard from "@/components/soldoutt/contents/ContentCard.vue";
import draggable from "vuedraggable";
import vSelect from "vue-select";
import moment from "moment";
import "vue-slick-carousel/dist/vue-slick-carousel.css";
// optional style for arrows & dots
import "vue-slick-carousel/dist/vue-slick-carousel-theme.css";

const short = require("short-uuid");
const translator = short();

export default {
  components: {
    Option,
    draggable,
    ContentCard,
    vSelect
  },
  props: ["page_id"],
  data() {
    const types = [
      "attendee-info",
      "post-event-survey",
      "pre-event-interest",
      "vote"
    ];
    const trueOrFalse = [
      { id: 1, name: "true" },
      { id: 0, name: "false" }
    ];
    return {
      drag: false,
      types: types,
      anonymous: trueOrFalse,
      trueOrFalse: trueOrFalse,
      valid: true,
      editorOption: {
        modules: {
          toolbar: "#toolbar"
        }
      },
      editorOption2: {
        modules: {
          toolbar: "#toolbar2"
        }
      },
      productsInSeller: [],
      StartPickerOptions: {},
      EndPickerOptions: {},
      page_title: "",
      page_description: "",
      contentDialog: false,
      activeTab: 0,
      page: null,
      contents: [],
      description_enabled_list: [],
      showTooltip: [],
      event_id: null,
      deleteIndex: -1,
      confirmDeleteDialog: false,
      errorDialog: false,
      cloneDialog: false,
      suggestedDialog: false,
      errorText: "",
      successDialog: false,
      successText: "",
      FilterDialog: false,
      FilterIndex: -1,
      addQDialog: false,
      pageDetailDialog: false,
      products: [],
      attendee_roles: [],
      remain_quantity: 0,
      showTicketTypeList: [],
      hideTicketTypeList: [],
      showRoleList: [],
      hideRoleList: [],
      validateDialog: false,
      validateIndex: -1,
      validateSelect: "",
      validateValue: {
        minlength: "",
        maxlength: "",
        rangelength: ["", ""],
        min: "",
        max: "",
        range: ["", ""],
        digits: true
      },
      validateTypeList: [
        "minlength",
        "maxlength",
        // "rangelength",
        "min",
        "max"
        // "range",
        // "step",
        // "email",
        // "url",
        // "date",
        // "dateiso",
        // "number",
        // "digits"
      ],
      sticking: false,
      eventList: [],
      selectedEventToClone: null,
      selectedEventContent: null,
      deleteContentList: [],
      banner: "",
      changeImage: false,
      showBtn: false,
      imageWidth: "auto",
      imageHeight: 600,
      BannerUpdate: null,
      acceptFile: ["image/png", "image/jpeg", "image/jpg", "image/webp"],
      popupActivo: false,
      bannerUploadUrl:
        process.env.VUE_APP_API_URL +
        "/events/" +
        this.$route.query.e +
        "/merchant/upload",
      bannerUploadHeader: {
        Authorization:
          "Bearer " +
          JSON.parse(localStorage.getItem("soldoutt-nimda")).Auth.accessToken
      },
      bannerData: {
        type: "banner"
      },
      merchant_id: -1,
      tags: [],
      tags_options: [],
      tag_item: {
        content_uuid: translator.new(),
        title: "Tag Row",
        entity_id: this.page_id,
        entity_type: "page",
        type: "tag_list",
        content_json: {
          content: {
            entity_ids: [],
            entity_type: "tag"
          },
          config: { source: "selected_then_dynamic", style: "chip", columns: 3 }
        },
        datetime_start: null,
        datetime_end: null,
        publish_status: 1,
        listing_status: 1,
        trash_status: null,
        trash_date: null,
        show: true
      },
      videos: [],
      selected_tag: ""
    };
  },
  computed: {
    ...mapState({
      s: state => {
        return state.Utility.s;
      },
      e: state => {
        return state.Utility.e;
      }
    }),
    tag_select_options() {
      return this.tags_options
        .filter(item => !this.tags.find(t => item.tag == t))
        .map(item => item.tag);
    },
    showticketOptions() {
      return this.products
        .filter(
          item => !this.hideTicketTypeList.find(t => t.value == item.product_id)
        )
        .map(item => {
          return {
            label: item.pro_name,
            value: item.product_id
          };
        });
    },
    showattendeeRoleOptions() {
      const hiderolelist = this.hideRoleList;
      return this.attendee_roles
        .filter(item => !hiderolelist.find(t => t.value == item.name))
        .map(item => {
          return {
            label: item.name,
            value: item.name
          };
        });
    },
    hideticketOptions() {
      return this.products
        .filter(
          item => !this.showTicketTypeList.find(t => t.value == item.product_id)
        )
        .map(item => {
          return {
            label: item.pro_name,
            value: item.product_id
          };
        });
    },
    hideattendeeRoleOptions() {
      return this.attendee_roles
        .filter(item => !this.showRoleList.find(t => t.value == item.name))
        .map(item => {
          return {
            label: item.name,
            value: item.name
          };
        });
    }
  },
  created() {
    this.$vs.loading();
    setTimeout(() => {
      this.fetchData();
    }, 1000);
  },
  mounted() {
    try {
      const observer = new IntersectionObserver(
        ([entry]) => {
          this.sticking = !entry.isIntersecting;
        },
        { threshold: 0.0 }
      );
      observer.observe(this.$refs.target);
    } catch (_) {
      console.log();
    }
  },
  methods: {
    addTag() {
      if (this.selected_tag) {
        this.tags.push(this.selected_tag);
        this.selected_tag = "";
      }
    },
    removeTag(tag) {
      if (this.tags.findIndex(t => t == tag) != -1) {
        this.tags.splice(
          this.tags.findIndex(t => t == tag),
          1
        );
      }
    },
    async loadTag() {
      let filterData = {
        e: this.e,
        s: this.s
      };

      let params = Object.keys(filterData)
        .map(key => key + "=" + filterData[key])
        .join("&");

      const res = await Service.Tags.gets(params);
      this.tags_options = res.data.tags;
      return res.data.tags;
    },
    async loadVideo() {
      let data = {
        event_type: "video",
        e: this.e,
        s: this.s,
        target: "merchant",
        perPage: 999
      };

      let params = Object.keys(data)
        .map(key => key + "=" + data[key])
        .join("&");

      const res = await Service.Video.gets(params);
      this.videos = res.data.rows;
    },
    setImageSize() {
      let bannerimage = document.querySelector("img");
      let w = bannerimage.naturalWidth;
      let h = bannerimage.naturalHeight;
      this.imageHeight = h;
      this.imageWidth = w;

      if (w > h) {
        this.imageWidth = 300;
        this.imageHeight = "auto";
      } else {
        this.imageHeight = 300;
        this.imageWidth = "auto";
      }
    },
    successBannerUpload(res, file) {
      this.banner = file[0];
      this.changeImage = false;
      this.showBtn = true;
      this.updateBanner(file[0]);
      // Service.Event.get({ ...this.form, e: this.e })
      // .then(res => {
      //     this.form = res.data.event.merchant;
      //     this.e = res.data.event.slug;
      // })
      // .catch(e => {
      //     /* this.$router.push("/pages/error-404").catch(() => {}); */
      // });
      // this.$vs.notify({
      //     color: "success",
      //     title: "Upload Success",
      //     text: "Banner upload success!"
      // });
    },
    changeImageBanner() {
      this.changeImage = true;
      this.showBtn = true;
    },
    removebanner() {
      this.popupActivo = false;
      this.banner = null;
      this.form.s = this.s;
      const formData = new FormData();
      const dataKeyForms = Object.keys(this.form);
      for (let index = 0; index < dataKeyForms.length; index++) {
        const key = dataKeyForms[index];
        const value = this.form[key] === null ? "" : this.form[key];
        formData.append(key, value);
      }
      formData.append("remove", "banner");
      formData.append("s", this.s);
      formData.append("e", this.e);

      Service.Content.uploadPageBanner(this.page_id, formData)
        .then(res => {
          // this.$vs.loading.close();
          this.$vs.notify({
            title: "Success",
            text: "Update complete.",
            color: "success"
          });
          this.banner = null;
          this.popupActivo = false;
        })
        .catch(e => {
          this.$vs.loading.close();
        });
    },
    updateBanner(file) {
      // this.banner = this.banner;
      const formData = new FormData();
      // const dataKeyForms = Object.keys(this.form);
      // for (let index = 0; index < dataKeyForms.length; index++) {
      //     const key = dataKeyForms[index];
      //     const value = this.form[key]  === null ? '': this.form[key];
      //     formData.append(key, value);
      // }
      formData.append("s", this.s);
      formData.append("e", this.e);
      formData.append("banner", file);
      Service.Content.uploadPageBanner(this.page_id, formData)
        .then(res => {
          this.changeImage = false;
          this.banner = res.data.path;
          // this.$vs.loading.close();
          this.$vs.notify({
            title: "Success",
            text: "Update complete.",
            color: "success"
          });
        })
        .catch(e => {
          this.$vs.loading.close();
        });
    },
    canceled() {
      this.$router.push("/sellers");
    },
    // successBannerUpload(res, file) {
    //   this.banner = file[0];
    //   console.log(this.banner, "this.banner");
    // },
    deleteFileBanner(res) {
      if (res) {
        this.banner = null;
      }
    },
    chooseImage() {
      document.getElementById("file-upload-img").click();
    },
    onUploadImages(file) {
      this.updateBanner(this.$refs.fileImage.files[0]);
      // this.banner = this.$refs.fileImage.files[0];
      const reader = new FileReader();
      reader.onloadend = async () => {
        this.banner = reader.result;

        // this.bannerUpdate = reader.result
        this.setImageSize();
      };
      reader.readAsDataURL(this.$refs.fileImage.files[0]);
      this.$refs.fileImage.value = null;
    },
    consolelog: console.log,
    jsonstrigfy: JSON.stringify,
    compareValues(key, order = "asc") {
      return function(a, b) {
        if (!a.hasOwnProperty(key) || !b.hasOwnProperty(key)) {
          return 0;
        }

        const varA = typeof a[key] === "string" ? a[key].toUpperCase() : a[key];
        const varB = typeof b[key] === "string" ? b[key].toUpperCase() : b[key];

        let comparison = 0;
        if (varA > varB) {
          comparison = 1;
        } else if (varA < varB) {
          comparison = -1;
        }
        return order == "desc" ? comparison * -1 : comparison;
      };
    },
    openFilterDialog(index) {
      this.FilterIndex = index;
      this.showTicketTypeList =
        this.contents[index].filter &&
        this.contents[index].filter.include &&
        this.contents[index].filter.include.product_id
          ? this.contents[index].filter.include.product_id.map(item => {
              return this.showticketOptions.find(s => s.value == item);
            })
          : [];
      this.hideTicketTypeList =
        this.contents[index].filter &&
        this.contents[index].filter.exclude &&
        this.contents[index].filter.exclude.product_id
          ? this.contents[index].filter.exclude.product_id.map(item => {
              return this.hideticketOptions.find(s => s.value == item);
            })
          : [];
      this.showRoleList =
        this.contents[index].filter &&
        this.contents[index].filter.include &&
        this.contents[index].filter.include.role
          ? this.contents[index].filter.include.role.map(item => {
              return this.showattendeeRoleOptions.find(s => s.value == item);
            })
          : [];
      this.hideRoleTypeList =
        this.contents[index].filter &&
        this.contents[index].filter.exclude &&
        this.contents[index].filter.exclude.role
          ? this.contents[index].filter.exclude.role.map(item => {
              return this.hideattendeeRoleOptions.find(s => s.value == item);
            })
          : [];
      this.FilterDialog = true;
    },
    submitFilter() {
      if (this.showTicketTypeList.length) {
        if (!this.contents[this.FilterIndex].filter.include) {
          this.contents[this.FilterIndex].filter.include = {};
        }
        this.contents[
          this.FilterIndex
        ].filter.include.product_id = this.showTicketTypeList.map(
          item => item.value
        );
      } else if (
        this.contents[this.FilterIndex].filter.include &&
        this.contents[this.FilterIndex].filter.include.product_id
      ) {
        delete this.contents[this.FilterIndex].filter.include.product_id;
      }
      if (this.showRoleList.length) {
        if (!this.contents[this.FilterIndex].filter.include) {
          this.contents[this.FilterIndex].filter.include = {};
        }
        this.contents[
          this.FilterIndex
        ].filter.include.role = this.showRoleList.map(item => item.value);
      } else if (
        this.contents[this.FilterIndex].filter.include &&
        this.contents[this.FilterIndex].filter.include.role
      ) {
        delete this.contents[this.FilterIndex].filter.include.role;
      }
      if (this.hideTicketTypeList.length) {
        if (!this.contents[this.FilterIndex].filter.exclude) {
          this.contents[this.FilterIndex].filter.exclude = {};
        }
        this.contents[
          this.FilterIndex
        ].filter.exclude.product_id = this.hideTicketTypeList.map(
          item => item.value
        );
      } else if (
        this.contents[this.FilterIndex].filter.exclude &&
        this.contents[this.FilterIndex].filter.exclude.product_id
      ) {
        delete this.contents[this.FilterIndex].filter.exclude.product_id;
      }
      if (this.hideRoleList.length) {
        if (!this.contents[this.FilterIndex].filter.exclude) {
          this.contents[this.FilterIndex].filter.exclude = {};
        }
        this.contents[
          this.FilterIndex
        ].filter.exclude.role = this.hideRoleList.map(item => item.value);
      } else if (
        this.contents[this.FilterIndex].filter.exclude &&
        this.contents[this.FilterIndex].filter.exclude.role
      ) {
        delete this.contents[this.FilterIndex].filter.exclude.role;
      }
      if (
        this.contents[this.FilterIndex].filter.include &&
        !this.contents[this.FilterIndex].filter.include.role &&
        !this.contents[this.FilterIndex].filter.include.product_id
      ) {
        delete this.contents[this.FilterIndex].filter.include;
      }

      if (
        this.contents[this.FilterIndex].filter.exclude &&
        !this.contents[this.FilterIndex].filter.exclude.role &&
        !this.contents[this.FilterIndex].filter.exclude.product_id
      ) {
        delete this.contents[this.FilterIndex].filter.exclude;
      }
      if (
        this.contents[this.FilterIndex].filter.length == 0 ||
        !Object.keys(this.contents[this.FilterIndex].filter).length
      ) {
        this.contents[this.FilterIndex].hasFilter = false;
      } else {
        this.contents[this.FilterIndex].hasFilter = true;
      }
      this.FilterDialog = false;
    },
    loadEvents() {
      let data = {
        s: this.s,
        page: 1
      };
      let params = Object.keys(data)
        .map(key => key + "=" + data[key])
        .join("&");

      this.$vs.loading();
      this.errorDialog = false;
      this.selectedEventToClone = null;
      this.selectedEventContent = null;
      this.cloneDialog = true;

      this.upcoming = { total: 0, from: 0, to: this.perPage, page: 1 };
      this.previous = { total: 0, from: 0, to: this.perPage, page: 1 };
      Service.Event.my(params)
        .then(res => {
          let e_main_list =
            res.data.rows.filter(x => x.parent_id == null) || [];
          let e_upcoming_list =
            res.data.rows.filter(x => x.workshop_listing_status == 1) || [];

          e_upcoming_list = e_upcoming_list
            .concat(e_main_list)
            .filter(item => item.e != this.e)
            .map(item => {
              return {
                label: item.pro_name,
                value: item.e
              };
            });

          this.eventList = e_upcoming_list;
          this.$vs.loading.close();
        })
        .catch(e => {
          console.error(e);
          this.$vs.loading.close();
        });
    },
    openValidationDialog(index) {
      this.validateIndex = index;
      const validation = this.contents[index].validations || {};
      this.validateSelect =
        this.validateTypeList.find(v => !!validation[v]) || "";
      this.validateValue = {
        minlength: validation.minlength || "",
        maxlength: validation.maxlength || "",
        rangelength: [
          validation.rangelength ? validation.rangelength[0] || "" : "",
          validation.rangelength ? validation.rangelength[1] || "" : ""
        ],
        min: validation.min || "",
        max: validation.max || "",
        range: [
          validation.range ? validation.range[0] || "" : "",
          validation.range ? validation.range[1] || "" : ""
        ],
        digits: true
      };
      this.validateDialog = true;
    },
    submitValidation() {
      this.contents[this.validateIndex].validations = {};
      if (this.contents[this.validateIndex].is_required) {
        this.contents[this.validateIndex].validations["required"] = true;
      }
      if (this.contents[this.validateIndex].type == "email") {
        this.contents[this.validateIndex].validations["email"] = true;
      }
      if (this.validateSelect) {
        this.contents[this.validateIndex].validations[
          this.validateSelect
        ] = this.validateValue[this.validateSelect];
      }
      this.validateDialog = false;
    },
    showMenu(index) {
      // Hide all other tooltips and toggle the current one
      this.showTooltip = this.showTooltip.map((_, i) => i === index);
    },
    showDeleteDialog(index) {
      this.deleteIndex = index;
      this.confirmDeleteDialog = true;
    },
    moveContentUp(index) {
      if (index > 0) {
        const temp = this.contents[index];

        this.contents[index] = this.contents[index - 1];

        this.contents[index - 1] = temp;
        this.refreshContent();
      }
    },
    moveContentDown(index) {
      if (index < this.contents.length - 1) {
        const temp = this.contents[index];

        this.contents[index] = this.contents[index + 1];

        this.contents[index + 1] = temp;
        this.refreshContent();
      }
    },
    loadOtherEventPage() {
      if (!this.selectedEventToClone) {
        return;
      }
      this.$vs.loading();
      let data = {
        e: this.selectedEventToClone.value,
        s: this.s
      };
      let params = Object.keys(data)
        .map(key => key + "=" + data[key])
        .join("&");
      Service.Content.getAttendeeInfoPage(params)
        .then(attendeeInfoRes => {
          let attendee_info_content_list = attendeeInfoRes.data.contents;

          for (let i = 0; i < attendeeInfoRes.data.contents.length; i++) {
            attendee_info_content_list[i].content_uuid = null;
            attendee_info_content_list[i].content_id = null;
          }
          this.selectedEventContent = attendee_info_content_list.map(item => {
            const description_enabled = !!item.content_shortdesc;
            const options = item.options_json;
            const condition_enabled =
              options &&
              options.find &&
              !!options.find(item => {
                return (
                  !!item.actions &&
                  !!item.actions.show_contents &&
                  !!item.actions.show_contents.length
                );
              });

            if (item.filter) {
              item.filter = JSON.parse(item.filter);
            }
            const hasFilter =
              item.filter &&
              ((item.filter.include && item.filter.include.product_id) ||
                (item.filter.exclude && item.filter.exclude.product_id) ||
                (item.filter.include && item.filter.include.role) ||
                (item.filter.exclude && item.filter.exclude.role));

            return {
              ...item,
              // max: max,
              options: options,
              description_enabled: description_enabled,
              condition_enabled: condition_enabled,
              show: true,
              filter: hasFilter ? item.filter : {},
              hasFilter
            };
          });
          this.$vs.loading.close();
        })
        .catch(() => {
          this.errorText = `This event has no attendee info.`;

          this.errorDialog = true;
          this.$vs.loading.close();
        });
    },
    cloneContent() {
      this.contents = this.selectedEventContent;
      this.cloneDialog = false;
    },
    loadSuggestedContents() {
      this.selectedSuggestedContent = null;
      this.suggestedDialog = true;
      this.errorDialog = false;
    },
    addSuggestedContent() {
      this.contents.push({
        page_id: this.page_id,
        page_uuid: this.page.page_uuid,
        content_uuid: translator.new(),
        event_id: this.event_id,
        title: this.selectedSuggestedContent.label,
        type: this.selectedSuggestedContent.value,
        listing_status: 1,
        is_required: 0,
        publish_status: true,
        page_filter: 1,
        current_round: 1,
        options: [],
        show: false
      });
      setTimeout(() => {
        this.contents[this.contents.length - 1].show = true;
      }, 150);
      this.suggestedDialog = false;
    },
    async fetchData() {
      this.$vs.loading();
      let data = {
        e: this.e,
        s: this.s,
        perPage: 999,
        page_id: this.page_id
      };

      Service.Event.get(this.e).then(res => {
        this.merchant_id = res.data.event.merchant.merchant_id;
        // this.banner = res.data.event.merchant.banner;
      });

      let params = Object.keys(data)
        .map(key => key + "=" + data[key])
        .join("&");

      // Service.Event.get(this.e || this.$route.query.e)
      //   .then(event => {
      //     this.event_id = event.data.event.event_id;
      //     const ticket_role_object = event.data.event.ticket_role
      //       ? JSON.parse(event.data.event.ticket_role)
      //       : {};
      //     const ticket_roles = Object.keys(ticket_role_object);
      //     this.attendee_roles = [];
      //     for (
      //       let ticket_roles_index = 0;
      //       ticket_roles_index < ticket_roles.length;
      //       ticket_roles_index++
      //     ) {
      //       this.attendee_roles.push(
      //         ticket_role_object[ticket_roles[ticket_roles_index]]
      //       );
      //     }
      //   })
      //   .catch(() => {
      //     this.$vs.loading.close();
      //   });

      // Service.Event.getProducts(this.e || this.$route.query.e).then(
      //   products => {
      //     this.products = products.data.items || [];

      //     this.remain_quantity = parseInt(products.data.remain_free);
      //     this.products.sort(this.compareValues("weight", "desc"));
      //   }
      // );

      Service.Product.getsInSeller(params).then(res => {
        this.productsInSeller = res.data.rows;
        this.productsInSeller.sort(this.compareValues("weight", "desc"));
      });

      let dataMyEvent = {
        e: this.e,
        s: this.s
      };

      let paramsMyEvent = Object.keys(dataMyEvent)
        .map(key => key + "=" + dataMyEvent[key])
        .join("&");

      Service.Event.myEventsWithoutDetail(paramsMyEvent)
        .then(res2 => {
          this.eventList = res2.data.rows;
        })
        .catch(error => {
          console.log(error);
        });

      await this.loadTag();

      await this.loadVideo();

      Service.Content.pageDetail(this.page_id, params)
        .then(res => {
          this.page = res.data;
          this.page_title = res.data.title;
          this.page_description = res.data.description;
          this.banner = res.data.banner;
          const tag_content = res.data.contents.find(
            item => item.type == "tag_list"
          );
          if (tag_content) {
            if (
              typeof tag_content.content_json === "string" ||
              tag_content.content_json instanceof String
            ) {
              try {
                tag_content.content_json = JSON.parse(tag_content.content_json);
              } catch (_) {
                tag_content.content_json = {};
              }
              tag_content.show = true;
            }
            this.tag_item = tag_content;
            this.tags = tag_content.content_json.content.entity_ids
              .map(item => {
                const tagItem = this.tags_options.find(
                  tag => tag.tag_id == item
                );
                if (tagItem) {
                  return tagItem.tag;
                }
                return null;
              })
              .filter(item => !!item);
          }
          this.contents = res.data.contents
            .filter(
              item => !tag_content || item.content_id != tag_content.content_id
            )
            .map(item => {
              if (
                typeof item.content_json === "string" ||
                item.content_json instanceof String
              ) {
                try {
                  item.content_json = JSON.parse(item.content_json);
                } catch (_) {
                  item.content_json = {};
                }
                item.show = true;
              }
              return item;
            });
        })
        .finally(() => {
          this.$vs.loading.close();
        });
    },
    refreshContent() {
      this.contents = JSON.parse(JSON.stringify(this.contents));
    },
    addContent(index = -1) {
      if (index == -1) {
        this.contents.push({
          content_uuid: translator.new(),
          title: "",
          entity_id: this.page_id,
          entity_type: "page",
          type: "item_list",
          content_json: {
            content: {
              entity_ids: [],
              entity_type: "video"
            },
            config: {
              source: "selected_then_dynamic",
              style: "grid",
              columns: 3
            }
          },
          datetime_start: null,
          datetime_end: null,
          publish_status: 1,
          listing_status: 1,
          trash_status: null,
          trash_date: null,
          show: false
        });
        setTimeout(() => {
          this.contents[this.contents.length - 1].show = true;
        }, 150);
      } else {
        this.contents.splice(index + 1, 0, {
          content_uuid: translator.new(),
          title: "",
          entity_id: this.page_id,
          entity_type: "page",
          type: "item_list",
          content_json: {
            content: {
              entity_ids: [],
              entity_type: "video"
            },
            config: {
              source: "selected_then_dynamic",
              style: "grid",
              columns: 3
            }
          },
          datetime_start: null,
          datetime_end: null,
          publish_status: 1,
          listing_status: 1,
          trash_status: null,
          trash_date: null,
          show: false
        });
        setTimeout(() => {
          this.contents[index + 1].show = true;
        }, 150);
      }
    },
    copyContent(index = -1) {
      if (index != -1) {
        const copyContent = {
          content_uuid: translator.new(),
          title: this.contents[index].title,
          entity_id: this.page_id,
          entity_type: "page",
          type: this.contents[index].type,
          content_json: this.contents[index].content_json,
          datetime_start: this.contents[index].datetime_start,
          datetime_end: this.contents[index].datetime_end,
          publish_status: this.contents[index].publish_status,
          listing_status: this.contents[index].listing_status,
          trash_status: this.contents[index].trash_status,
          trash_date: this.contents[index].trash_date,
          show: false
        };
        // delete copyContent.content_id;
        this.contents.splice(index + 1, 0, copyContent);
        setTimeout(() => {
          this.contents[index + 1].show = true;
        }, 150);
      }
    },
    openContentDialog() {
      this.contentDialog = true;
    },
    onContentClose() {
      this.contentDialog = false;
    },
    onContentSubmit() {
      this.contentDialog = false;
      this.fetchData();
    },
    removeContent(index) {
      // remove the content at the specified index
      this.confirmDeleteDialog = false;
      this.deleteContentList.push(this.contents[index]);
      this.contents.splice(index, 1);
    },
    async submitContent() {
      this.$vs.loading();
      this.page.title = this.page_title;
      this.page.description = this.page_description;
      this.page.banner = this.banner;
      try {
        await Service.Content.updatePage(this.page_id, {
          ...this.page,
          e: this.e,
          s: this.s
        });
        const contents_for_updates = this.contents.map((item, index) => {
          return {
            ...item,
            datetime_start: item.datetime_start
              ? moment(item.datetime_start).format("YYYY-MM-DD HH:mm")
              : null,
            datetime_end: item.datetime_end
              ? moment(item.datetime_end).format("YYYY-MM-DD HH:mm")
              : null,
            content_json: JSON.stringify(item.content_json),
            weight: this.contents.length * 100 - index * 100
          };
        });

        for (let i = 0; i < this.deleteContentList.length; i++) {
          if (
            this.deleteContentList[i] &&
            this.deleteContentList[i].content_id
          ) {
            this.deleteContentList[i] = {
              content_id: this.deleteContentList[i].content_id,
              trash_status: 1
            }
          }
        }

        this.tag_item.content_json.content.entity_ids = this.tags
          .map(item => {
            const tagItem = this.tags_options.find(tag => tag.tag == item);
            if (tagItem) {
              return tagItem.tag_id;
            }
            return null;
          })
          .filter(item => !!item);
        const tag_item_for_update = {
          ...this.tag_item,
          content_json: JSON.stringify(this.tag_item.content_json),
          weight: 9000
        };

        const create_list = [];
        const update_list = [];

        for (let i = 0; i < contents_for_updates.length; i++) {
          if (contents_for_updates[i] && contents_for_updates[i].content_id) {
            update_list.push(contents_for_updates[i]);
          } else if (contents_for_updates[i]) {
            create_list.push(contents_for_updates[i]);
          }
        }
        if (update_list.length) {
          await Service.Content.updateContent({
            contents: update_list,
            e: this.e,
            s: this.s
          });
        }
        if (this.deleteContentList.length) {
          await Service.Content.updateContent({
            contents: this.deleteContentList,
            e: this.e,
            s: this.s
          });
        }

        if (tag_item_for_update.content_id) {
          await Service.Content.updateContent({
            contents: [tag_item_for_update],
            e: this.e,
            s: this.s
          });
        } else {
          await Service.Content.addContent({
            contents: [tag_item_for_update],
            e: this.e,
            s: this.s
          });
        }
        if (create_list.length) {
          await Service.Content.addContent({
            contents: create_list,
            e: this.e,
            s: this.s
          });
        }
        this.fetchData();
      } catch (e) {
        this.errorText = "";
        if (e.errors) {
          for (const [errorKey, errorItem] of Object.entries(e.errors)) {
            for (const [subErrorKey, subErrorItem] of Object.entries(
              errorItem
            )) {
              this.errorText += "\n" + subErrorItem;
            }
          }
          this.errorDialog = true;
        }
      }

      this.$vs.loading.close();
      // Service.Content.updateContentList(page)
      //   .then(res => {
      //     if (res.success) {
      //       // const data = res.data;
      //       // const dataPage = data.page;

      //       // this.$vs.notify({
      //       //   title: "Success",
      //       //   text: "Update complete.",
      //       //   color: "success",
      //       // });
      //       this.successText = "Update complete.";
      //       this.successDialog = true;
      //     }
      //     this.$vs.loading.close();
      //   })
      //   .catch(err => {
      //     this.successText = "ERROR : " + err.error;
      //     this.successDialog = true;
      //     this.$vs.loading.close();
      //   });
    },
    validateUpdatePage() {
      this.$validator.validateAll().then(result => {
        if (result) {
          // if page have no errors
          this.submitUpdatePage();
        } else {
          // page have errors
        }
      });
    },
    submitUpdatePage() {
      this.$vs.loading();

      this.page = {
        ...this.page
      };

      Service.Content.update(this.page.page_id, this.page)
        .then(res => {
          if (res.success) {
            const data = res.data;

            this.$vs.notify({
              title: "Success",
              text: "Update complete.",
              color: "success"
            });

            this.$router.push("/pages/" + data.page.page_id);
          }
          this.$vs.loading.close();
        })
        .catch(err => {
          this.$vs.notify({
            title: "Oops!",
            text: "ERROR : " + err.error,
            color: "danger"
          });
          this.$vs.loading.close();
        });

      console.log("submit loading...", this.page);
    },
    validatePage() {
      this.submitContent();
    }
  }
};
</script>
<style scoped>
.remove-content-button {
  cursor: pointer;
  color: red;
  margin-left: 10px;
  /* position: absolute;
  right: 5px;
  top: 0; */
  font-size: 30px;
}
.tooltip-container {
  position: relative;
  display: inline-block;
}

.tooltip-menu {
  position: absolute;
  top: 100%;
  left: 0;
  z-index: 1000;
  background-color: #fff;
  border: 1px solid #ccc;
  padding: 5px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  min-width: 100px;
}

.tooltip-menu div {
  cursor: pointer;
  padding: 5px;
}

/* Style the 3 dots icon (you may need to adjust this based on your icon library) */
i.fas.fa-ellipsis-v {
  cursor: pointer;
}
.ghost {
  /* background: red; */
  background: #f8f8f8;
}

.list-enter-active,
.list-leave-active {
  transition: all 0.5s ease;
}
.list-enter-from,
.list-leave-to {
  opacity: 0;
  transpage: translateX(30px);
}
.filter-table * {
  font-size: 1.3rem !important;
}

.sticky-menu {
  background-color: #fff;
  padding: 1rem;
  position: sticky;
  top: 62px;
  z-index: 999;
}

.sticky-menu .sticking {
  background-color: #fff;
  box-shadow: 0 8px 12px 0 rgba(0, 0, 0, 0.3);
}
input[type="file"] {
  display: none !important;
}
</style>

<style>
.flip-list-move {
  transition: transform 0.5s;
}

.no-move {
  transition: transform 0s;
}

.ghost {
  opacity: 0.5;
  background: #c8ebfb;
}

.list-group {
  min-height: 20px;
}

.list-group-item {
  cursor: move;
}

.list-group-item i {
  cursor: pointer;
}
.con-vs-tabs,
.vs-card--content {
  overflow: visible !important;
}

.filter-table .vs__selected {
  font-size: 1.1rem !important;
}
.filter-popup .vs-popup {
  height: 400px !important;
}

.filter-popup .vs-popup--content {
  height: 100%;
  overflow: visible;
  position: relative;
}

.suggested-popup .vs-popup--content {
  height: 100%;
  overflow: visible;
  position: relative;
}
.vs-input--placeholder.large {
  font-size: 1.2rem;
}

div.page-title input.vs-input--input {
  font-size: 1.8rem !important;
}

div.page-title .vs-input--placeholder {
  font-size: 1.8rem;
}
.content-popup .vs-popup {
  height: 400px !important;
}
</style>
